<template>
  <dialog
    class="InviteUserModalView"
    data-theme="light"
    aria-label="Invite a player to your crew"
    open
  >
    <div
      class="InviteUserModalView__backdrop"
      data-testid="backdrop"
      @click="$emit('close')"
    />
    <section
      class="InviteUserModalView__window"
    >
      <div class="InviteUserModalView__track">
        <InviteCard
          v-for="crew in commissionerCrews"
          :key="crew.id"
          :name="crew.name"
          :joinUrl="getAppUrl(`/crews/${crew.id}/join`)"
        />
      </div>
    </section>
  </dialog>
</template>

<script lang="ts" setup>
import InviteCard from "@/components/InviteCard.vue";
import getAppUrl from "@/lib/utils/http/getAppUrl";
import useCurrentPlayerStore from "@/stores/useCurrentPlayerStore";
import { storeToRefs } from "pinia";
import { onBeforeMount } from "vue";

defineEmits<{
  close: [],
}>();

const {
  fetchCrewMemberships,
} = useCurrentPlayerStore();
const {
  commissionerCrews,
} = storeToRefs(useCurrentPlayerStore());

onBeforeMount(() => {
  try {
    fetchCrewMemberships();
  } catch (err) {
    console.error(err);
  }
});
</script>

<style lang="scss" scoped>
.InviteUserModalView {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  isolation: isolate;

  display: grid;
  place-items: center;
  width: 100%;
  height: 100%;
  padding: 24px 16px;

  transition: none 350ms;
}

.InviteUserModalView__backdrop {
  position: absolute;
  inset: 0;
  z-index: -1;

  background-color: var(--themeColorBackdrop);
  backdrop-filter: blur(6px);

  transition: opacity 335ms cubic-bezier(0.25, 1, 0.30, 1);

  .v-leave-active & {
    transition: 350ms;
    transition-timing-function: initial;
  }

  .v-enter-from &,
  .v-leave-to & {
    opacity: 0;
  }
}

.InviteUserModalView__window {
  display: grid;
  width: 100%;

  .v-enter-active & {
    transition: 335ms cubic-bezier(0.25, 1, 0.30, 1);
    transition-property: opacity, transform;
  }

  .v-leave-active & {
    transition: 350ms;
    transition-property: opacity;
  }

  .v-enter-from & {
    transform: scale(0.8);
    opacity: 0;
  }

  .v-leave-to & {
    opacity: 0;
  }
}

.InviteUserModalView__track {
  display: grid;
  grid-auto-columns: 100%;
  grid-auto-flow: column;
  gap: 24px;
  margin-inline: -16px;
  padding-inline: 16px;
  overflow-x: auto;

  scroll-snap-type: x mandatory;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
}
</style>
